(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ZetasrealtimeDetailController', ZetasrealtimeDetailController);

    ZetasrealtimeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zetasrealtime'];

    function ZetasrealtimeDetailController($scope, $rootScope, $stateParams, previousState, entity, Zetasrealtime) {
        var vm = this;

        vm.zetasrealtime = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:zetasrealtimeUpdate', function(event, result) {
            vm.zetasrealtime = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
